import {
  DEFAULT_DATE_PICKER_MAX_DATE,
  DEFAULT_DATE_PICKER_MIN_DATE,
} from "../../shared/components/Datepicker/datepicker.constants";
import { TECH_FORM_TYPED_DATE_PATTERN } from "../models/tech-form-validation-ui.constants";
import { TECH_FORM_VALIDATION_CONFIG } from "../models/tech-form-validation.constants";

export function calendarDateForEditing(value: Date | string | null): Date | null {
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
  if (typeof value !== "string") return null;
  const parts = value.match(TECH_FORM_VALIDATION_CONFIG.patterns.date);
  if (!parts || !Number.isFinite(Date.parse(value))) return null;
  const year = Number(parts[1]),
    month = Number(parts[2]),
    day = Number(parts[3]);
  const date = new Date(0);
  date.setHours(0, 0, 0, 0);
  date.setFullYear(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}
export function calendarDateForStorage(value: Date | null): string | null {
  if (!value || !Number.isFinite(value.getTime())) return null;
  return (
    String(value.getFullYear()).padStart(4, "0") +
    "-" +
    String(value.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(value.getDate()).padStart(2, "0")
  );
}

export function calendarDateFromTypedText(value: string): string {
  const parts = value.trim().match(TECH_FORM_TYPED_DATE_PATTERN);
  if (!parts) return value;
  const iso = parts[3] + "-" + parts[1].padStart(2, "0") + "-" + parts[2].padStart(2, "0");
  const date = calendarDateForEditing(iso);
  return date && date >= DEFAULT_DATE_PICKER_MIN_DATE && date <= DEFAULT_DATE_PICKER_MAX_DATE ? iso : value;
}
